import React from 'react';
import {Menu, MenuButton, MenuItem, MenuItems, Transition} from "@headlessui/react";
import {FaChevronDown} from "react-icons/fa";

const ToolbarColorBtn = ({strokeColor, disabled, onChange}) => {
    const colors = [
        { name: "red", hex: "#FF0000" },
        { name: "orange", hex: "#FF5F00" },
        { name: "yellow", hex: "#CCFF00" },
        { name: "green", hex: "#39FF14" },
        { name: "cyan", hex: "#00FFFF" },
        { name: "blue", hex: "#007BFF" },
        { name: "indigo", hex: "#6F00FF" },
        { name: "magenta", hex: "#FF00FF" },
        { name: "pink", hex: "#FF00BF" },
        { name: "black", hex: "#000000" },
        { name: "white", hex: "#FFFFFF" }
    ];

    return (
        <Menu>
            <MenuButton className="image-editor-button" title={"Cores"} disabled={disabled}>
                <span className="image-editor-button-icon rounded-4 default-border" style={{backgroundColor: strokeColor}}/>
                <FaChevronDown className="image-editor-button-dropdown-small" />
            </MenuButton>
            <Transition
                enter="transition ease-out duration-75"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <MenuItems anchor="bottom" className="heading-dropdown-color">
                    {
                        colors.map((item) => {
                            const isActive = item.name === strokeColor;

                            return (
                                <MenuItem key={"color-" + item.name}>
                                    <button
                                        className={"image-editor-button" + (isActive ? " active" : "")}
                                        onClick={() => onChange(item.hex)}
                                        style={{backgroundColor: item.hex}}
                                    />
                                </MenuItem>
                            )
                        })
                    }
                </MenuItems>
            </Transition>
        </Menu>
    );
};

export default ToolbarColorBtn;